<template>
  <VLayout>
    <div class="container">
      <vue-element-loading :active="loading_poll" />
      <div class="header pt-4">
        <router-link :to="{name: 'home'}">
          <SVGLogo class="logo_medika_xs w-50 mx-auto d-block" />
        </router-link>
        <div class="title mt-4 text-center">{{ $t('poll.title') }}</div>
        <div
          class="subtitle mt-4 text-center"
        >{{ $t('poll.subtitle') }}</div>
      </div>
      <div class="questions mt-4 text-center">
        <b-form @submit="sendForm" v-if="show" id="poll">
          <div class="question">
            {{ $t('poll.question_estimate_time') }}
            <div class="options text-center">
              <b-form-group>
                <input
                  v-model.trim="form.answer_estimate_time"
                  type="radio"
                  name="answer_estimate_time"
                  :value="false"
                  class="sad"
                  required
                />
                <input
                  v-model.trim="form.answer_estimate_time"
                  type="radio"
                  name="answer_estimate_time"
                  :value="true"
                  class="happy"
                />
              </b-form-group>
            </div>
          </div>
          <div class="question">
            {{ $t('poll.question_scheduled_time') }}
            <div class="options text-center">
              <input
                v-model.trim="form.answer_scheduled_time"
                type="radio"
                name="answer_scheduled_time"
                :value="false"
                class="sad"
                required
              />
              <input
                v-model.trim="form.answer_scheduled_time"
                type="radio"
                name="answer_scheduled_time"
                :value="true"
                class="happy"
              />
            </div>
          </div>
          <div class="question">
            {{ $t('poll.question_complete_order') }}
            <div class="options text-center">
              <input
                v-model.trim="form.answer_complete_order"
                type="radio"
                name="answer_complete_order"
                :value="false"
                class="sad"
                required
              />
              <input
                v-model.trim="form.answer_complete_order"
                type="radio"
                name="answer_complete_order"
                :value="true"
                class="happy"
              />
            </div>
          </div>
          <div class="question">
            {{ $t('poll.question_verified_drug') }}
            <div class="options text-center">
              <input
                v-model.trim="form.answer_verified_drug"
                type="radio"
                name="answer_verified_drug"
                :value="false"
                class="sad"
                required
              />
              <input
                v-model.trim="form.answer_verified_drug"
                type="radio"
                name="answer_verified_drug"
                :value="true"
                class="happy"
              />
            </div>
          </div>
          <div class="question">
            {{ $t('poll.question_modified_order') }}
            <div class="options text-center">
              <input
                v-model.trim="form.answer_modified_order"
                type="radio"
                name="answer_modified_order"
                :value="false"
                class="sad"
                required
              />
              <input
                v-model.trim="form.answer_modified_order"
                type="radio"
                name="answer_modified_order"
                :value="true"
                class="happy"
              />
            </div>
          </div>
          <div class="question">
            {{ $t('poll.question_rating') }}
            <div class="options text-center">
              <input
                v-model.trim="form.rating"
                type="radio"
                name="rating"
                value="1"
                class="sad rating"
                required
              />
              <input
                v-model.trim="form.rating"
                type="radio"
                name="rating"
                value="3"
                class="neutral rating"
              />
              <input
                v-model.trim="form.rating"
                type="radio"
                name="rating"
                value="4"
                class="happy2 rating"
              />
              <input
                v-model.trim="form.rating"
                type="radio"
                name="rating"
                value="5"
                class="happy rating"
              />
            </div>
          </div>
          <div class="comments">
            <div class="question">{{ $t('poll.question_comments') }}</div>
            <textarea
              v-model.trim="form.comments"
              name="comments"
              class="mt-3 w-100"
              rows="6"
              cols="60"
            ></textarea>
          </div>
          <div class="question">
            <div
              class="subtitle mt-4 text-center"
            >{{ $t('poll.question_file') }}</div>
            <b-form-file
              id="file_poll"
              name="file_poll"
              :placeholder="$t('poll.question_file_placeholder')"
              :browse-text="$t('poll.question_file_button')"
              class="mt-3"
              v-model="form.file_poll"
            ></b-form-file>
          </div>
          <div class="submit mt-3">
            <b-button type="submit" variant="primary" size="xl">{{ $t('poll.submit_button') }}</b-button>
          </div>
        </b-form>
      </div>
      <div class="footer mt-4 text-center">
        {{ $t('poll.questions') }}
        <hr />
        <div class="social mt-4">{{ $t('poll.social') }}</div>
        <div class="mt-4 mb-4">
          <SocialIcons></SocialIcons>
        </div>
      </div>
    </div>
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Empty";
import SVGLogo from "@/static/logo_global_store.svg";
import SocialIcons from "@/components/SocialIcons";

export default {
  components: {
    VLayout,
    SVGLogo,
    SocialIcons,
  },
  data() {
    return {
      loading_poll: true,
      show: false,
      form: {
        answer_estimate_time: undefined,
        answer_scheduled_time: undefined,
        answer_complete_order: undefined,
        answer_verified_drug: undefined,
        answer_modified_order: undefined,
        rating: undefined,
        comments: undefined,
        file_poll: undefined,
      },
      form_invalid_feedback: {},
      form_state: {},
    };
  },
  computed: {
    id: function() {
      return this.$route.query.id;
    },
  },
  created() {
    if (!this.id) {
      this.$router.push({ name: "home" });
    }
    this.loadPoll();
  },
  methods: {
    loadPoll() {
      this.$store
        .dispatch("polls/LOAD_POLL", {
          pollId: this.id,
        })
        .then(
          response => {
            this.show = true;
            this.loading_poll = false;
            this.form = response.data;
          },
          err => {
            this.$sentry({ capture: err });
            this.mnotify_error({
              text: this.$t("poll.error.poll_retrieve_error"),
            });
            this.$router.push({ name: "home" });
          }
        );
    },
    sendForm(evt) {
      evt.preventDefault();
      this.loading_poll = true;
      var data = this.form;
      var payload = { pollId: this.id };
      payload.data = data;
      if (this.form.file_poll) {
        let formData = new FormData();
        formData.append("file_poll", this.form.file_poll);
        formData.append(
          "file_poll_filename",
          this.form.file_poll.name
        );
        formData.append(
          "file_poll_filename",
          this.form.file_poll.name
        );
        formData.append('answer_estimate_time', this.form.answer_estimate_time);
        formData.append('answer_scheduled_time', this.form.answer_scheduled_time);
        formData.append('answer_complete_order', this.form.answer_complete_order);
        formData.append('answer_verified_drug', this.form.answer_verified_drug);
        formData.append('answer_modified_order', this.form.answer_modified_order);
        formData.append('rating', this.form.rating);
        formData.append('comments', this.form.comments);
        payload.data=formData;
      }
      this.$store.dispatch("polls/UPDATE_POLL", payload).then(
        () => {
          this.loading_poll = false;
          this.$router.push({ name: "home" });
          this.mnotify_success({
            text: this.$t("poll.error.poll_retrieve_error"),
          });
        },
        err => {
          this.loading_poll = false;
          this.showResponseError(err);
          this.putFormFeedback(err.response);
          this.mnotify_error({
            text: this.$t("poll.error.poll_retrieve_error"),
          });
        }
      );
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        poll: {
          title: "We want to know your experience with Vooy Market",
          subtitle: "You deserve a world class service. We invite you to evaluate the quality of service",
          question_estimate_time: "Do we comply with the estimated delivery time?",
          question_scheduled_time: "Did your order arrive at the scheduled time?",
          question_complete_order: "Did you receive your complete order?",
          question_verified_drug: "Did you verify that the expiration batch indicated on your bill coincided with your medication?",
          question_modified_order: "Does the status of the package and / or packaging of your product indicate that it was altered in any way?",
          question_rating: "In general How would you rate your experience with Vooy Market?",
          question_comments: "Comments:",
          question_file: "Attach a photo with your comment (Optional)",
          question_file_placeholder: "No file chosen",
          question_file_button: "Browse",
          questions: "Do you have any doubt? Write to customer-service@vooymarket.com. Thank you very much for trusting Vooy Market",
          social: "Remember that you can follow us on social networks",
          submit_button: "Send",
          complete: "Thank you for completing the poll",
          error: {
            poll_retrieve_error: "Cannot retrieve poll",
          },
        },
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 75%;
}
@include media-breakpoint-down(md) {
  .container {
    width: 100%;
  }
  .rating {
    margin: 0.4rem !important;
    margin-top: 2rem !important;
  }
  .b-form-file{
    text-align: left;
  }
}
.header {
  border-top-style: solid;
  border-top-color: $corp-color1;
}
.footer {
  border-bottom-style: solid;
  border-bottom-color: $corp-color1;
}
.title {
  color: $corp-color1;
  font-size: $font-size-medium * 1.5;
}
.social {
  color: $grey5-color;
}
.subtitle {
  font-size: $font-size-medium;
}
.question {
  font-size: $font-size-medium;
  font-weight: bold;
}

// Custom radio buttons
form {
  &#poll {
    input[type="radio"] {
      -webkit-appearance: none;
      width: 60px;
      height: 60px;
      border: none;
      cursor: pointer;
      transition: border 0.2s ease;
      margin: 0 5px;
      opacity: 0.5;
      transition: all 0.2s ease;

      &:hover,
      &:checked {
        opacity: 1;
      }

      &:focus {
        outline: 0;
      }

      &.happy {
        margin: 2rem;
        background: url("~@/static/poll/smiley_green.png") center;
        background-size: cover;
      }
      &.happy2 {
        margin: 2rem;
        background: url("~@/static/poll/smiley_green2.png") center;
        background-size: cover;
      }
      &.neutral {
        margin: 2rem;
        background: url("~@/static/poll/smiley_yellow.png") center;
        background-size: cover;
      }
      &.sad {
        margin: 2rem;
        background: url("~@/static/poll/smiley_red.png") center;
        background-size: cover;
      }
    }
  }
}

</style>
